import './header';
import './hero';
import './dynamic-text-resizing';
import './services-slider';
import './quotes-slider';
// rotation.tsx is built and enqueued separately for the block editor (editor-only).
// Do not import it here, as it would include editor code in the frontend bundle and
// cause runtime errors when `wp` is undefined.

document.addEventListener('DOMContentLoaded', () => {
  console.log('DOM fully loaded and parsed');
  // Wrap 'Protected: ' in a span for styling
  document.querySelectorAll<HTMLElement>('.wp-block-post-title').forEach(el => {
    if (el.textContent && el.textContent.trim().startsWith('Protected: ')) {
      // Only wrap if not already wrapped
      if (!el.innerHTML.startsWith('<span class="protected-prefix"')) {
        el.innerHTML = el.innerHTML.replace(
          /^Protected: /,
          '<span class="protected-prefix">Protected: </span>'
        );
      }
    }
  });
});
